/**
 * Tarjeta de capítulo: la app queda desenfocada detrás y aparece "Capítulo N ·
 * título · bajada" durante ~2,5 s (lo maneja el motor). No bloquea clics.
 */
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import type { EngineState } from './engine';

export function ChapterCard({ card }: { card: EngineState['card'] }) {
  const { t } = useTranslation();
  const reduce = useReducedMotion();
  return (
    <AnimatePresence>
      {card && (
        <motion.div
          key={card.n}
          className="pointer-events-none fixed inset-0 z-204 flex items-center justify-center bg-[#050d0c]/60 px-6 backdrop-blur-xs"
          initial={reduce ? false : { opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.35 }}
        >
          <motion.div
            className="max-w-3xl text-center"
            initial={reduce ? false : { y: 14, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.45, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
          >
            <div className="text-xs font-semibold uppercase tracking-[0.35em] text-brand-green">
              {t('vault.workshop.chapter', 'Capítulo {{n}}', { n: card.n })}
              <span className="text-brand-green/50"> · {card.n}/{card.total}</span>
            </div>
            <h2 className="mt-3 font-display text-4xl leading-tight text-white md:text-6xl" style={{ textWrap: 'balance' }}>
              {card.title}
            </h2>
            <p className="mt-4 text-lg text-white/70 md:text-xl">{card.subtitle}</p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
